/**
 * Centralised access to runtime config. Anything sourced from `import.meta.env`
 * gets a typed default and a documented name so refactors don't break silently.
 */

export const env = {
  /** Backend base URL — empty in dev because Vite proxies /api -> :8000. */
  apiBase: import.meta.env.VITE_API_BASE ?? "",
  /** 짧은 제품명 (로고 옆·탭 등). */
  appName: "GARAMe gasM",
  /** 풀 제품명 i18n 키 — 모듈 스코프에 한국어를 두지 않고 렌더 시점에 t() 로 현지화. */
  appTitleKey: "common.appTitle",
  /** 앱 버전 — package.json 단일 소스 (vite define 주입). */
  version: __APP_VERSION__,
  build:   (import.meta.env.VITE_BUILD_ID as string | undefined) ?? "dev",
} as const;
